import { Observable } from 'rxjs';
import {
  downloadFileDto,
  GetCustomerFileListDto,
} from 'src/app/data/dtos/access-file/access-file.dto';
import { RefreshTokenDto } from 'src/app/data/dtos/auth/auth.dto';
import {
  GetDistrictRequestDto,
  GetDistrictResponseDto,
  GetHousingTypeResponseDto,
  GetOccupationGroupResponseDto,
  GetOccupationRequestDto,
  GetOccupationResponseDto,
  GetPostCodeRequestDto,
  GetPostCodeResponseDto,
  GetProvinceResponseDto,
  GetSubDistrictRequestDto,
  GetSubDistrictResponseDto,
} from 'src/app/data/dtos/data-dict/data-dict.dto';
import {
  NdidCheckRequestResponseDto,
  NdidRequestDataResponseDto,
} from 'src/app/data/dtos/ndid/ndid.dto';
import {
  GetAddressResponseDto,
  UpdateAddressRequestDto,
  updateTypeAddressRequestDto,
} from 'src/app/data/dtos/onboarding/address.dto';
import { GetAutoApproveResponse } from 'src/app/data/dtos/onboarding/auto-approve.dto';
import { VerifyIdCardNumberRequestDto } from 'src/app/data/dtos/onboarding/bulk.dto';
import { confirmDataRequestDto, confirmDataResponseDto } from 'src/app/data/dtos/onboarding/confirm-data.dto';
import {
  ConfirmOTPRequestDto,
  ContactRequestDto,
  SendOTPRequestDto,
} from 'src/app/data/dtos/onboarding/contact.dto';
import {
  DeleteDocumentRequestDto,
  UploadDocumentRequestDto,
  UploadOcrDocumentRequestDto,
  UploadSelfieRequestDto,
} from 'src/app/data/dtos/onboarding/document-source.dto';
import { GetLoanTypeListResponseDto } from 'src/app/data/dtos/onboarding/loan-type.dto';
import { PersonalInfoUpdateRequestDto, PersonalInfoUpdateResponseDto } from 'src/app/data/dtos/onboarding/personal-info.dto';
import { GetPersonalLoanResponseDto } from 'src/app/data/dtos/onboarding/personal-loan.dto';
import {
  confirmPersonalLoanRequestDto,
  confirmProductRequestDto,
  getProductlistRequestDto,
  getProductlistResponseDto,
  GetProductResponseDto,
  setLoanTypeRequestDto,
  setProductRequestDto,
} from 'src/app/data/dtos/onboarding/product.dto';
import { getResumeStateResponseDto } from 'src/app/data/dtos/onboarding/resume.dto';
import {
  StartKYCRequestDto,
  StartKYCResponseDto,
} from 'src/app/data/dtos/onboarding/start-kyc.dto';
import {
  getCurrentStateResponseDto,
  UpdateCurrentStepRequestDto,
} from 'src/app/data/dtos/onboarding/state.dto';
import {
  AcceptTermAndConsentRequestDto,
  AcceptTermAndConsentResponseDto,
  GetTermAndConsentRequestDto,
  GetTermAndConsentResponseDto,
} from 'src/app/data/dtos/onboarding/term-consent.dto';
import {
  BeginTransactionRequestDto,
  BeginTransactionResponseDto,
  CheckLimitPolicyResponse,
  CloseKycResponseDto,
  CompareUserDataResponseDto,
  GetDocumentResponseDto,
  GetSelfieResponseDto,
  GetTxnResponseDto,
  OnBoardingTransactionRequestDto,
  OptionalOnBoardingTransactionRequestDto,
  UpdateDocumentRequestDto,
} from 'src/app/data/dtos/onboarding/transaction.dto';
import { LoanInfoResponseDto } from 'src/app/data/dtos/onboarding/user-info.dto';
import { UpdateWorkingRequestDto } from 'src/app/data/dtos/onboarding/working.dto';
import { ResponseDto } from 'src/app/data/dtos/response.dto';

export class StarMoneyNotFoundError extends Error { }

export abstract class StarMoneyAdapterService {
  abstract beginTxn(
    request: BeginTransactionRequestDto
  ): Observable<ResponseDto<BeginTransactionResponseDto>>;
  abstract signInAnonymous(
    request: OptionalOnBoardingTransactionRequestDto
  ): Observable<ResponseDto<any>>;
  abstract refreshToken(request: RefreshTokenDto): Observable<ResponseDto<any>>;
  abstract startKyc(
    request: StartKYCRequestDto
  ): Observable<ResponseDto<StartKYCResponseDto>>;
  abstract getWorkFlow(): Observable<ResponseDto<any>>;
  abstract getCurrentWorkFlow(): Observable<ResponseDto<any>>;
  abstract getTermAndConsent(
    request: GetTermAndConsentRequestDto
  ): Observable<ResponseDto<GetTermAndConsentResponseDto>>;
  abstract acceptTermAndConsent(
    request: AcceptTermAndConsentRequestDto
  ): Observable<ResponseDto<boolean | AcceptTermAndConsentResponseDto>>;

  abstract getLoanTypeList(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<GetLoanTypeListResponseDto>>;
  abstract setLoanType(
    request: setLoanTypeRequestDto
  ): Observable<ResponseDto<any>>;
  abstract getLoanType(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<any>>;

  abstract updateContact(
    request: ContactRequestDto
  ): Observable<ResponseDto<any>>;
  abstract getContact(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<any>>;
  abstract getWorking(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<any>>;
  abstract updateWorking(
    request: UpdateWorkingRequestDto
  ): Observable<ResponseDto<any>>;
  abstract sendOTP(request: SendOTPRequestDto): Observable<ResponseDto<any>>;
  abstract confirmOTP(
    request: ConfirmOTPRequestDto
  ): Observable<ResponseDto<any>>;
  abstract getAddress(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<GetAddressResponseDto[]>>;
  abstract updateAddress(
    request: UpdateAddressRequestDto
  ): Observable<ResponseDto<any>>;
  abstract updateTypeAddress(
    request: updateTypeAddressRequestDto
  ): Observable<ResponseDto<any>>;
  abstract uploadDocument(
    request: UploadDocumentRequestDto
  ): Observable<ResponseDto<any>>;
  abstract getUploadFile(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<any>>;
  abstract uploadOcrDocument(
    request: UploadOcrDocumentRequestDto
  ): Observable<ResponseDto<boolean>>;
  abstract processDoc(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<boolean>>;
  abstract getDocument(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<GetDocumentResponseDto>>;
  abstract compareUserData(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<boolean | CompareUserDataResponseDto>>;
  abstract updateDocument(
    request: UpdateDocumentRequestDto
  ): Observable<ResponseDto<boolean>>;
  abstract verifyDocument(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<boolean>>;
  abstract reject(request: OnBoardingTransactionRequestDto): Observable<any>;

  /**
   * Abstract method to retrieve a selfie associated with an onboarding transaction.
   * @param request - The OnBoardingTransactionRequestDto containing the necessary transaction information.
   * @returns An Observable containing a ResponseDto with the GetSelfieResponseDto data.
   */

  abstract getSelfie(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<GetSelfieResponseDto>>;

  abstract uploadSelfie(
    request: UploadSelfieRequestDto
  ): Observable<ResponseDto<boolean>>;
  /**
   * Call when user press button 'Process'
   * @param request OnBoardingTransactionRequestDto
   * @returns Observable of ResponseDto<boolean>
   */
  abstract updateProcessing(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<boolean>>;
  abstract closeKyc(
    request: OnBoardingTransactionRequestDto,
    idempotencyKey: string
  ): Observable<ResponseDto<CloseKycResponseDto | boolean>>;

  // NDID
  abstract ndidRequestData(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<NdidRequestDataResponseDto>>;
  abstract ndidGetConsent(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<string>>;
  abstract ndidCheckRequest(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<NdidCheckRequestResponseDto>>;
  abstract ndidCheckStatus(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<NdidCheckRequestResponseDto>>;
  //--------------
  abstract getProvince(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<GetProvinceResponseDto[]>>;

  abstract getHousingType(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<GetHousingTypeResponseDto[]>>;

  abstract getOccupationGroup(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<GetOccupationGroupResponseDto[]>>;

  abstract getOccupation(
    request: GetOccupationRequestDto
  ): Observable<ResponseDto<GetOccupationResponseDto[]>>;

  abstract getDistrict(
    request: GetDistrictRequestDto
  ): Observable<ResponseDto<GetDistrictResponseDto[]>>;

  abstract getSubDistrict(
    request: GetSubDistrictRequestDto
  ): Observable<ResponseDto<GetSubDistrictResponseDto[]>>;

  abstract getPostCode(
    request: GetPostCodeRequestDto
  ): Observable<ResponseDto<GetPostCodeResponseDto[]>>;

  abstract getInfo(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<LoanInfoResponseDto>>;

  abstract deleteFile(
    request: DeleteDocumentRequestDto
  ): Observable<ResponseDto<any>>;

  abstract ndidCancelVerify(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<any>>;

  abstract getProductList(
    request: getProductlistRequestDto
  ): Observable<ResponseDto<getProductlistResponseDto[]>>;

  abstract getProduct(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<GetProductResponseDto>>;

  abstract setProduct(
    request: setProductRequestDto
  ): Observable<ResponseDto<boolean>>;

  abstract confirmProduct(
    request: confirmProductRequestDto
  ): Observable<ResponseDto<any>>;

  abstract getPersonalLoan(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<GetPersonalLoanResponseDto>>;

  abstract getNanoFinance(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<GetPersonalLoanResponseDto>>;

  abstract confirmPersonalLoan(
    request: confirmPersonalLoanRequestDto
  ): Observable<ResponseDto<boolean>>;

  abstract confirmNanoFinance(
    request: confirmPersonalLoanRequestDto
  ): Observable<ResponseDto<boolean>>;

  abstract updateCurrentStep(
    request: UpdateCurrentStepRequestDto
  ): Observable<ResponseDto<boolean>>;

  abstract getCurrentState(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<getCurrentStateResponseDto>>;

  abstract confirmData(
    request: confirmDataRequestDto
  ): Observable<ResponseDto<confirmDataResponseDto>>;

  //resume state
  abstract resumeState(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<getResumeStateResponseDto>>;

  //customer access file
  abstract customerAccessFile(
    request: GetCustomerFileListDto
  ): Observable<ResponseDto<any>>;

  abstract customerDownloadFile(request: downloadFileDto): Observable<any>;

  abstract saveCameraLog(request: any): Observable<ResponseDto<any>>;

  abstract verifyIdCardNumber(
    request: VerifyIdCardNumberRequestDto
  ): Observable<any>;

  abstract checkLimitPolicy(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<CheckLimitPolicyResponse>>;

  abstract getTxn(
    request: OnBoardingTransactionRequestDto,
  ): Observable<ResponseDto<GetTxnResponseDto>>;

  abstract getAutoApprove(
    request: OnBoardingTransactionRequestDto,
  ): Observable<ResponseDto<GetAutoApproveResponse>>;

  abstract updatePersonalInfo(
    request: PersonalInfoUpdateRequestDto,
  ): Observable<ResponseDto<PersonalInfoUpdateResponseDto>>;

  abstract getPersonalInfo(
    request: OnBoardingTransactionRequestDto,
  ): Observable<ResponseDto<PersonalInfoUpdateResponseDto>>;


}
